import axios from 'axios';
import client from './apiClient';
import {
  VoxRoiConfigRequest,
  VoxRoiConfigResponse,
  VoxProductCatalogItem,
  VoxRoiUsageResponse,
} from '../models/voxRoi';

export const getVoxRoiConfig = async (): Promise<VoxRoiConfigResponse | null> => {
  try {
    const { data } = await client.get<VoxRoiConfigResponse>('/verifications/roi/config');
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const updateVoxRoiConfig = async (request: VoxRoiConfigRequest): Promise<void> => {
  await client.put('/verifications/roi/config', request);
};

export const getVoxRoiCatalog = async (): Promise<VoxProductCatalogItem[]> => {
  const { data } = await client.get<VoxProductCatalogItem[]>('/verifications/roi/catalog');
  return data;
};

export const getVoxRoiUsage = async ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<VoxRoiUsageResponse> => {
  const { data } = await client.get<VoxRoiUsageResponse>('/verifications/roi/usage', {
    params: { startDate, endDate },
  });
  return data;
};
